import React from 'react';
import AppConfig from '../../appConfig';

const Index = ({ isIRUser }) => {

    return (<div>
            <iframe id="ifrmCubes" width="100%" style={{ border: 'none', height: 'calc(100vh - 85px)', margin: '-20px', width:'calc(100vw - 69px)' }} src={AppConfig.baseUrl + 'Cubes/Index'} />
    </div>)
}

export default Index;